
import { PropTypes } from 'prop-types';
import { useState } from 'react';
import ModelButton from '../modelBtn/modelButton';
import PeopleDetail from './peopleDetail';
const PeopleCard = ({ people }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const {quote,location,designation,img} = people

    const closed = () => setModalOpen(false);
    const open = () => setModalOpen(true);
    return (
        <>
            <div className="w-11/12 sm:w-96 h-[30rem]  relative border cursor-pointer  group select-none  bg-slate-500/30 rounded-3xl overflow-hidden bg-cover bg-no-repeat bg-center" style={{ backgroundImage: `url('${img}')` }}
                onClick={() => (modalOpen ? closed() : open())}
            >
                <div className='absolute w-full h-full top-0 bg-gradient-to-b from-black/20 to-black/40 z-30 opacity-0 group-hover:opacity-100 transition-all duration-500'></div>
                <div className="absolute bottom-0 w-full h-2/5 2xl:h-1/3 bg-gradient-to-b from-black/30 to-black/80 bg-opacity-10 p-4">
                    <div className="flex flex-col justify-start h-full gap-3 ">
                        <h1 className="text-white flex-1 flex items-start  text-justify font-bold text-lg sm:text-2xl 2xl:text-lg">&ldquo;{quote}&rdquo;</h1>
                        {location && <p className="text-white text-sm   2xl:text-sm">{location}</p>}
                        
                        <p className="text-white flex-1 text-sm  flex items-start flex-col  2xl:text-sm">{designation}</p>
                    </div>
                </div>

            </div>
            <ModelButton modalOpen={modalOpen} close={closed}>
                <PeopleDetail people={people} />
            </ModelButton>
        </>
    )
}
PeopleCard.propTypes = {
  people:PropTypes.object
}
export default PeopleCard